import {create} from 'zustand';

import {NotificationType} from '../types/notifications.types';

export interface NotificationsStore {
  selectedTab: NotificationType;
  setSelectedTab: (selectedTab: NotificationType) => void;
}

export const useNotificationsStore = create<NotificationsStore>((set) => ({
  selectedTab: 'all',
  setSelectedTab: (selectedTab) => set({selectedTab}),
}));
